$(document).ready(function () {
	// Entferne Error Class nach KLICK
	$(".error-line").click(function() {
		$(this).removeClass('error-line');
		$(".cr").removeClass('error-line');
	});
	$(".konto-navigation-button").click(function() {
		$("#konto-navigation").show();
		$("#search-button-click").hide();
		$("#shopping-cart-click").hide();
	});
	// Bestellung Details anzeigen
	$(".bestellungen-detail").click(function () {
		var id		= $(this).attr("id").replace("bestellungen_detail_","");
		$("#bestell-daten-loader-" + id).show();
		$("#details_oben_" + id).removeClass("d-block");
		$("#details_oben_" + id).addClass("d-none");
		$.ajax ({
			type: 'GET',
			url: '/warenkorb/ajax_bestellung_details',
			data: 'bestellung_id=' + id,
			cache: false,
			success: function (html) {
				$("#wako_bestellungen_artikel_" + id).removeClass("d-none");
				$("#wako_bestellungen_artikel_" + id).addClass("d-block");
				$("#bestell-daten-loader-" + id).hide();
				$("#wako_bestellungen_artikel_" + id).html(html);
				$("#details_unten_" + id).removeClass("d-none");
				$("#details_unten_" + id).addClass("d-block");
			}
		});
	});
	$(".dropdown-menu a[href^='#']").on('click', function(e) {
		// prevent default anchor click behavior
		e.preventDefault();

		// animate
		$('html, body').animate({
		 	scrollTop: $(this.hash).offset().top - 60
			}, 300, function(){
		});
	});
});

// Warenkorb hinzufuegen Funktion
function warenkorb_add(artikel_id,artikel_typ) {
	$.ajax({
		type: 'GET'
		,url: '/warenkorb/ajax_add_artikel'
		,data: 'artikel_id=' + artikel_id + '&artikel_typ=' + artikel_typ
		,cache: false
		,success: function(xml,textStatus) {
			if ($('success', xml).text() == 'true') {
				$(".wako-anzahl-header").html($('basket_count', xml).text());
				$("#shopping-cart-click").addClass("wako-aktiv");
				window.parent.update_wakobox_and_show();
			}
		}
		,error: function (XMLHttpRequest, textStatus, errorThrown) {
			alert("Artikel konnte nicht in den Warenkorb gelegt werden.");
		}
	});
}

// Warenkorb loeschen Funktion
function warenkorb_delete(artikel_id,artikel_typ) {
	$.ajax({
		type: 'GET'
		,url: '/warenkorb/ajax_delete_artikel'
		,data: 'artikel_id=' + artikel_id + '&artikel_typ=' + artikel_typ
		,cache: false
		,success: function(xml,textStatus) {
			if ($('success', xml).text() == 'true') {
				$(".wako-anzahl-header").html($('basket_count', xml).text());
				if ( $('basket_count', xml).text() == 0 ) {
					$("#shopping-cart-click").removeClass("wako-aktiv");
				}
				window.parent.update_wakobox_and_show();
			}
		}
		,error: function (XMLHttpRequest, textStatus, errorThrown) {
			alert("Der Artikel konnte nicht gelöscht werden.");
		}
	});
}

// Löschen Funktion aus Bestellen-Schritt
function delete_wako_list_item(artikel_id,artikel_typ,anzahl,type) {
	$("#shopping-table-loader").show();
	$("#wako-liste").hide();
	$.ajax({
		type: 'GET'
		,url: '/warenkorb/ajax_wako_table'
		,data: 'artikel_id=' + artikel_id + '&artikel_typ=' + artikel_typ + '&anzahl=' + anzahl + '&type=' + type
		,cache: false
		,success: function(html,textStatus) {
			$("#wako-liste").html(html);
			$("#shopping-table-loader").hide();
			$("#wako-liste").show();
			$(".wako-anzahl-header").html($("#titel-summierte-anzahl").val());
			update_bezahltypen($("#wako-summe").val(),$("#versandkosten").val(),$("#e-book-vorhanden").val());
			// Wenn kein Artikel mehr im Wako dann Absenden Button deaktivieren
			if ( $("#artikel-counter").val() == 0 ) {
				button = $('#wako-bestellen');
				button.attr('disabled','disabled');
				$("#shopping-cart-click").removeClass("wako-aktiv");
			}
		}
		,error: function (XMLHttpRequest, textStatus, errorThrown) {
			alert("Es ist ein Fehler aufgetreten.");
		}
	});
}

// UPDATE Bezahltypen updaten
function update_bezahltypen(wako_summe,versandkosten,e_book_vorhanden) {
	$("#shopping-bezahltypen-loader").show();
	$("#ppplus").hide();
	$.ajax({
		type: 'GET'
		,url: '/warenkorb/ajax_wako_bezahltypen'
		,data: 'wako_summe=' + wako_summe + '&versandkosten=' + versandkosten + '&e_book_vorhanden=' + e_book_vorhanden
		,cache: false
		,success: function(html,textStatus) {
			$("#ajax-wako-bezahltypen").html(html);
			$("#ppplus").show();
			$("#shopping-bezahltypen-loader").hide();
		}
		,error: function (XMLHttpRequest, textStatus, errorThrown) {
			alert("Es ist ein Fehler aufgetreten.");
		}
	});
}

// Warenkorb Overlay updaten und anzeigen
function update_wakobox_and_show() {
	$("#shopping-cart-overlay").show();
	$.ajax({
		type: "POST"
		,url: '/warenkorb/ajax_shopping_cart'
		,success: function(html,textStatus){
			$("#shopping-cart-overlay").html(html);
			$("#shopping-cart-overlay").show();
			$("#search-button-click").hide();
			$("#shopping-cart-click").hide();
		},
		error: function(){
			alert("Beim Laden des Warenkorbs ist ein Fehler aufgetreten.");
		}
	});
}

// Bestellen Submit abfrühstücken
function handle_submit() {
	//stop submit the form, we will post it manually.
    event.preventDefault();
	$(".wako-button").hide();
	$("#ajax-absenden-placeholder").show();
	var form_data = $('#wako_submit_order_form').serialize();
	handle_bestellvorgang(form_data);
}

// Bestellvorgang updaten/checken
function handle_bestellvorgang(form_data) {
	$.ajax({
		type: 'GET'
		,url: '/warenkorb/ajax_wako_update_bestellvorgang'
		,data: form_data
		,cache: false
		,success: function(xml,textStatus) {
			if ($('success', xml).text() == 'true') {
				ppp.doContinue();
				$(".wako-button").show();
				$("#ajax-absenden-placeholder").hide();
			} else {
				var url = window.location.href.split('?')[0];
				url += '?widerruf=0'
				window.location.href = url;
			}
		}
		,error: function (XMLHttpRequest, textStatus, errorThrown) {
			alert("Es ist ein Fehler aufgetreten.");
		}
	});
}

// Close Overlays
function close_overlay() {
	$("#shopping-cart-overlay").hide();
	$("#search-button-click").show();
	$("#shopping-cart-click").show();
}

function close_konto_overlay(element) {
	$(element).hide();
	$("#search-button-click").show();
	$("#shopping-cart-click").show();
}